import React from 'react';
import './footer.css';
import 'font-awesome/css/font-awesome.min.css';


<div className="footer-section social-media">
  <h2>Follow Us</h2>
  <div className="social-icons">


    <a href="" className="social-icon"><i className="fa fa-linkedin"></i></a>

   
  </div>
</div>


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section quick-links">
          <h2>Quick Links</h2>
          <ul>
            <li><a href="/advancesearch">advanced search</a></li>

            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactus">Contact Us</a></li>
            <li><a href="/login">Login</a></li>
          </ul>
        </div>

        <div className="footer-section quick-links">
          <h2>Information</h2>
          <ul>
            <li><a href="/faqs">FAQs</a></li>
            <li><a href="/termsandconditions"> Terms & Conditions</a></li>
            <li><a href="/privacyandpolicies">Privacy & Policies</a></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:digitallibrary@eyecareinstitute.lk">digitallibrary@eyecareinstitute.lk</a></p>
          <p>Phone: 0112 682 277</p>
          <p>Location: 932, Maradana Road, Colombo 08, Sri Lanka.</p>
        </div>
        <div className="footer-section social-media">
          <h2>Follow Us</h2>
          <div className="social-icons">
          <a href="https://www.facebook.com/EYECARESRILANKA" 
              target="_blank"
              rel="noopener noreferrer" 
              className="social-icon"><i className="fa fa-facebook"></i></a>

            <a href="https://www.linkedin.com/company/eye-care-institute-%E2%80%93-vision-health-education/" 
               target="_blank"
               rel="noopener noreferrer" 
            className="social-icon linkedin">
                <i className="fa fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/eyecareinstitutesl?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"><i className="fa fa-instagram"></i></a>

            <a href="https://www.youtube.com/@eyecareinstitutesrilanka8780" 
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"><i className="fa fa-youtube"></i></a>
          </div>
        
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Eye Care Digital Library. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
